var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVipPointIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4765 9.59741C23.1718 7.9509 22.9164 3.52844 22.8788 2.85505C22.7969 3.5409 20.1069 4.68782 16.6793 5.47785C13.2396 6.27068 10.3105 6.41507 9.95335 5.82713C10.2053 6.43007 11.9428 10.6083 12.3964 12.2511C12.8763 13.9894 13.3434 17.7845 13.3434 17.7845L13.3435 17.7849C13.4984 18.4571 16.2481 18.3971 19.4851 17.651C22.7221 16.9049 25.2206 15.7552 25.0657 15.083L25.0656 15.0827C25.0656 15.0827 23.8089 11.3944 23.4765 9.59741Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5253 13.8663C28.95 15.7085 25.08 18.1731 19.8815 19.3713C14.683 20.5695 10.1247 20.0474 9.70007 18.2053C9.27546 16.3631 13.9142 17.234 19.1127 16.0358C24.3112 14.8376 28.1007 12.0241 28.5253 13.8663Z",
    fill: "#242424"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0933 14.0097C25.6358 14.2873 25.9042 14.9677 25.6908 15.5566C25.3285 16.5558 24.2296 16.9888 23.3467 17.2851C21.9766 17.7449 20.5832 18.2459 19.1817 18.5823C17.7682 18.9217 13.7475 19.5378 10.7564 18.5244C10.3897 18.4001 10.0268 18.2594 9.6798 18.0838C9.68427 18.123 9.69047 18.1632 9.70018 18.2053C10.1248 20.0475 14.6831 20.5695 19.8816 19.3713C25.0801 18.1731 28.9501 15.7085 28.5255 13.8663C28.2917 12.8526 27.0386 13.2488 25.0933 14.0097Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2028 16.9371C14.1928 17.2102 15.3435 17.1416 16.3325 16.9759C16.9672 16.8695 17.585 16.6867 18.2076 16.5273C18.8418 16.365 19.4854 16.243 20.1202 16.0827C20.7299 15.9287 21.331 15.7418 21.9399 15.5839C22.0253 15.5618 22.1107 15.5395 22.1961 15.5173C22.1456 15.4394 22.1053 15.3524 22.0795 15.2582C22.0711 15.2281 22.0656 15.1979 22.0614 15.1676C21.1458 15.4882 20.1585 15.7948 19.1128 16.0358C16.7878 16.5717 14.5751 16.6937 12.877 16.8297C12.9828 16.8696 13.0908 16.9063 13.2028 16.9371Z",
    fill: "#242424"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.874 2.76833L22.6186 2.82718C22.1078 3.45118 21.3571 3.84057 20.6469 4.18754C20.5601 4.22986 20.4686 4.25488 20.3768 4.26336C19.933 4.44538 19.4691 4.57156 19.0317 4.7696C18.9781 4.79387 18.9229 4.81167 18.8672 4.8245C19.0709 5.25402 19.2644 5.68853 19.4365 6.13358C20.0894 7.82429 20.4227 9.63672 19.919 11.3899C19.4956 12.8637 18.4532 14.1382 17.1681 14.8142C15.8965 15.4831 14.3657 15.5066 13.0181 14.9278C12.987 14.9145 12.9572 14.8993 12.9265 14.8853C13.1702 16.378 13.3433 17.7846 13.3433 17.7846L13.3434 17.785C13.4983 18.4572 16.248 18.3972 19.485 17.6511C22.722 16.9051 25.2205 15.7554 25.0656 15.0832L25.0655 15.0828C25.0655 15.0828 23.8089 11.3946 23.4765 9.59753C23.1464 7.81315 22.874 2.76833 22.874 2.76833Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3901 12.9959C23.8605 13.6707 21.6551 14.5875 18.9241 15.217C16.1978 15.8454 13.8174 15.987 13.0416 15.6145C13.223 16.8056 13.3435 17.7845 13.3435 17.7845L13.3436 17.7848C13.4985 18.457 16.2482 18.3971 19.4852 17.651C22.7222 16.9049 25.2207 15.7552 25.0658 15.083L25.0657 15.0826C25.0655 15.0827 24.7481 14.151 24.3901 12.9959Z",
    fill: "#E8C754"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.875 2.76809C23.0299 3.44018 20.256 4.65347 16.6793 5.47785C13.1027 6.30222 10.0776 6.42567 9.92263 5.75347C9.76761 5.08142 12.5416 3.86825 16.1182 3.04387C19.6948 2.21949 22.7201 2.09601 22.875 2.76809Z",
    fill: "#242424"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6172 24.6661C11.7508 24.301 11.8178 23.991 11.8178 23.7353C11.8178 23.2735 11.6626 22.983 11.3518 22.8639C11.0414 22.7451 10.594 22.6862 10.0101 22.6862V22.157H14.4134V22.6862C13.6315 22.6862 13.0717 23.1849 12.7342 24.1822L7.53619 39.1253H7.07821L1.647 24.0635C1.43243 23.4495 1.20769 23.0661 0.971919 22.9143C0.736572 22.7625 0.412599 22.6862 0 22.6862V22.157H7.07821V22.6862C5.7819 22.6862 5.13395 23.0085 5.13395 23.653C5.13395 23.8112 5.16872 23.9605 5.23827 24.1L8.49199 33.6334L11.6172 24.6661Z",
    fill: "url(#paint0_linear_14200_29111)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7682 36.1328C20.7682 37.5075 21.4479 38.1945 22.8087 38.1945V38.7144H15.337V38.1945C16.6973 38.1945 17.3775 37.5071 17.3775 36.1328V24.7386C17.3775 23.3702 16.6973 22.6862 15.337 22.6862V22.157H22.8087V22.6862C21.4479 22.6862 20.7682 23.3702 20.7682 24.7386V36.1328Z",
    fill: "url(#paint1_linear_14200_29111)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9629 36.1328C28.9629 36.7714 29.1194 37.2747 29.4328 37.6424C29.7461 38.0105 30.1812 38.1945 30.7384 38.1945V38.7144H23.829V38.1945C24.3701 38.1945 24.7958 38.0105 25.1062 37.6424C25.417 37.2747 25.5722 36.7714 25.5722 36.1328V24.7386C25.5722 24.1 25.4183 23.5983 25.11 23.2332C24.8022 22.8681 24.3751 22.6858 23.8285 22.6858V22.157H30.6332C31.8117 22.157 32.8103 22.3211 33.63 22.6497C34.4497 22.9779 35.0764 23.6136 35.5098 24.5562C35.8363 25.2619 36 26.0069 36 26.7914C36 28.1475 35.5073 29.2577 34.5218 30.121C33.6436 30.8932 32.4032 31.2795 30.802 31.2795H28.9625V36.1328H28.9629ZM28.9629 30.495C29.8466 30.4709 30.5828 30.339 31.1722 30.0981C31.7616 29.8581 32.1628 29.3183 32.3774 28.4791C32.5326 27.9558 32.6102 27.3931 32.6102 26.7914C32.6102 26.0922 32.5114 25.4077 32.3133 24.7386C31.9385 23.5708 31.2261 22.9868 30.1761 22.9868C29.7313 23.0233 29.4183 23.0827 29.2364 23.1645C29.0541 23.2468 28.9633 23.5343 28.9633 24.0266V30.495H28.9629Z",
    fill: "url(#paint2_linear_14200_29111)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14200_29111",
    x1: 7.21891,
    y1: 19.7184,
    x2: 12.7494,
    y2: 38.9256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#793700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0402,
    stopColor: "#813E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1025,
    stopColor: "#975100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1791,
    stopColor: "#BA7000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2662,
    stopColor: "#EB9B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    stopColor: "#F3A200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#FFF78E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    stopColor: "#F3A200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14200_29111",
    x1: -1.36912,
    y1: 22.0499,
    x2: 0.673919,
    y2: 42.0805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#793700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0402,
    stopColor: "#813E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1025,
    stopColor: "#975100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1791,
    stopColor: "#BA7000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2662,
    stopColor: "#EB9B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    stopColor: "#F3A200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#FFF78E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    stopColor: "#F3A200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14200_29111",
    x1: 24.8745,
    y1: 21.3363,
    x2: 33.1376,
    y2: 39.0832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#793700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0402,
    stopColor: "#813E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1025,
    stopColor: "#975100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1791,
    stopColor: "#BA7000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2662,
    stopColor: "#EB9B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    stopColor: "#F3A200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#FFF78E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    stopColor: "#F3A200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793700"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipPointIcon);
export default __webpack_public_path__ + "static/media/vip-point-icon.cfc27bbf8ab1968fed5c40f6899065d1.svg";
export { ForwardRef as ReactComponent };